const es={
	"home":{
        "name": "home",
        "url":"/",
        "title": "LEVTY",
        "description": "Equipos especializados para impulsar la transformación digital de su organización. Cree equipos de desarrollo para acelerar la construcción de su proyecto y lanzar productos digitales de alta calidad."
    },

    "specializedTeams": {
        "title": "Equipos especializados en transformación digital",
        "description": "Equipos de profesionales calificados en una plataforma digital corporativa que trabajan con dedicación como parte de su organización."
    },

    "teamAsService":{
        "title": "Team as a service",
        "description": "Proporcionamos a su organización uno o más equipos de ingenieros de software capacitados en una plataforma digital para cumplir con sus requisitos."
    },

    "management":{
        "title": "Gestión y flexibilidad",
        "description": "Nuestros equipos adoptan una metodología especializada, herramientas online para gestionar proyectos ágiles y comunicación a través de chat, teléfono fijo y correo electrónico.",
        "features":[
            {
                "title":"Productividad",
                "description":"Nuestro equipo de desarrollo utiliza metodologías ágiles, asegurando la eficiencia de las entregas."
            },
            {
                "title":"Previsibilidad de costos",
                "description":"Plantillas personalizadas según el perfil de su organización. "
            },
            {
                "title":"Equipo escalable",
                "description":"Reúna equipos multidisciplinarios para construir y publicar proyectos de calidad."
            },
            {
                "title":"Profesionales calificados",
                "description":"Equipos experimentados con ingenieros de software trabajarán exclusivamente en su proyecto."
            },
            {
                "title":"Transparencia",
                "description":"Realice un seguimiento de las entregas, la visibilidad de backlog y el estado a través de un canal de comunicación directo."
            },
            {
                "title":"Retención de talentos",
                "description":"Nuestros profesionales son elegidos con discreción y ofrecemos diferentes ventajas para que se involucren plenamente en su proyecto."
            }
        ]
    },

    "teamsModels":{
        "title": "Modelos de equipo para cada escala empresarial",
        "description": "Nuestros modelos de equipo incluyen, además del equipo de desarrollo de software, el Director de Unidad y el Gerente de Cuentas.",
        "packs": [
            {
                "title":"Mínimo",
                "description": "2 Ingenieros de Software",
                "scrum": "1 Scrum Master / Product Owner / Líder de Desarrollo",
                "dev": "1 Desarrollador"
            },
            {
                "title":"Básico",
                "description": "3 Ingenieros de Software",
                "scrum": "1 Scrum Master / Product Owner",
                "devLead": "1 Líder de Desarrollo",
                "dev":"1 Desarrollador"
            },
            {
                "title":"Completo",
                "description": "5 Ingenieros de Software",
                "scrum": "1 Scrum Master / Product Owner",
                "devLead": "1 Líder de Desarrollo",
                "dev":"3 Desarrolladores"
            }
        ]
    },

    "ourTechnology":{
        "title": "Nuestra Tecnología",
        "description": "Somos socios oficiales de SYDLE, especializados en la plataforma SYDLE ONE, incluidas sus soluciones.",
        "bpm":"BPM",
        "ecm":"ECM",
        "crm":"CRM",
        "billing":"Billing",
        "ecommerce":"E-commerce",
        "servicedesk":"Service Desk/ITSM",
        "powerManagement":"Gestión de energía",
        "analytics":"Analytics",
        "learnMore":"Saber más"
    },

    "buildTeam":{
        "title": "Construya un equipo para su organización",
        "description": "Cuente con nuestra flexibilidad para diseñar equipos cohesionados en función de sus objetivos y necesidades. Póngase en contacto con nosotros para más información."
    },
    
    "button":{
        "plans":"Planes",
        "contact":"Entrar en contacto",
        "learnMore":"Saber más"
    }, 

    "customers": {
        "title": "Conoce a nuestros clientes",
        "description": "Empresas que confían en los equipos de expertos en transformación digital de LEVTY."    
    }
} 
export default es